(function () {
  function initSlot(slot) {
    const el = slot.querySelector('.elux-media-el');
    if (!el) return;

    const markLoaded = () => {
      slot.classList.add('is-loaded');
      slot.classList.remove('is-missing');
    };
    const markMissing = () => {
      slot.classList.add('is-missing');
      slot.classList.remove('is-loaded');
    };

    const tryFallback = () => {
      const fb = slot.getAttribute('data-fallback-src');
      if (!fb || el.dataset.fallbackTried === '1') {
        markMissing();
        return;
      }
      el.dataset.fallbackTried = '1';
      if (el.tagName === 'IMG') el.src = fb;
      else if (el.tagName === 'VIDEO') el.src = fb;
    };

    if (el.tagName === 'IMG') {
      if (el.complete && el.naturalWidth > 0) markLoaded();
      else if (el.complete) tryFallback();
      el.addEventListener('load', markLoaded);
      el.addEventListener('error', tryFallback);
    } else if (el.tagName === 'VIDEO') {
      el.addEventListener('loadeddata', markLoaded);
      el.addEventListener('error', tryFallback);
      if (el.readyState >= 2) markLoaded();
    }
  }

  function initAll() {
    document.querySelectorAll('.elux-media-slot').forEach(initSlot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
